module.exports = __webpack_public_path__ + "img/TierTwoAlternatives_02_LRT.3002522b.jpg";